import React from "react";
import { Button, ButtonGroup } from "@mui/material";
import { ArrowDropDown as ArrowDropDownIcon } from "@mui/icons-material";

const TableActionSplitButton = ({
  onView,
  onOpenMenu,
  menuId,
  menuOpen = false,
}) => (
  <ButtonGroup variant="outlined" color="info" size="small">
    <Button
      onClick={onView}
      aria-label="View details"
      sx={{ minWidth: 48, px: 1 }}
    >
      View
    </Button>
    <Button
      size="small"
      aria-label="Open row download options"
      aria-controls={menuOpen ? menuId : undefined}
      aria-expanded={menuOpen ? "true" : undefined}
      aria-haspopup="menu"
      onClick={onOpenMenu}
      sx={{ minWidth: 30, px: 0.5 }}
    >
      <ArrowDropDownIcon fontSize="small" />
    </Button>
  </ButtonGroup>
);

export default TableActionSplitButton;
